<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Resumen por Jornada</h3>
        </b-col>
        <b-col class="text-right">
          <!-- Botón para alternar la visibilidad de la tabla -->
          <base-button @click="mostrarTabla = !mostrarTabla" size="sm" type="primary">
            {{ mostrarTabla ? 'Ocultar -' : 'Mostrar +' }}
          </base-button>
        </b-col>
      </b-row>
    </template>

    <el-table v-if="mostrarTabla"
    class="table-responsive"
    style="width: 100%"
    :data="datosConsolidados" 
    row-key="jornada" header-row-class-name="thead-light">

    <el-table-column
    type="expand">
    <template #default="props">
      <!-- Contenido del detalle, mostrado cuando la fila se expande -->
              <el-table
          :data="props.row.transportes"
          style="width: 100%"
          default-sort="{prop: 'transporte', order: 'ascending'}">
          <el-table-column
            prop="transporte"
            label="Transporte"
            min-width="150px"
            sortable
            :sort-method="ordenarBodega">
            <template #default="props">
              <strong>{{ props.row.transporte }}</strong>
            </template>
          </el-table-column>
          <el-table-column min-width="30px" prop="viajes" label="Viajes"></el-table-column>
          <el-table-column min-width="30px" prop="cantidadCamiones" label="Camiones" ></el-table-column>
          <el-table-column min-width="40px"
            prop="transporte"
            label="Peso Salida"
            >
            <template #default="props">
              <div>
           {{ props.row.pesoNetoSalida }} TM 
          </div>            </template>
          </el-table-column>
          <el-table-column min-width="40px"
            prop="transporte"
            label="Peso Ingreso"
            >
            <template #default="props">
              <div>
           {{ props.row.pesoNetoIngreso }} TM 
          </div>            </template>
          </el-table-column>

          <el-table-column min-width="40px"
            prop="transporte"
            label="Diferencia"
            >
            <template #default="props">
              <div :style="{ color: props.row.diferenciaPeso < 0 ? '#F59221' : '#529E02' }">
           <b>{{ props.row.diferenciaPeso }} TM</b>    
          </div>            </template>
          </el-table-column>
        </el-table>
        </template>
      </el-table-column>

      <el-table-column label="Jornada" min-width="60px" prop="jornada">
                  <template  #default="props">
                  <b :style="{ color: obtenerColorJornada(props.row.jornada) }">  
                    {{ props.row.jornada }} </b>
                  </template>
                </el-table-column>
      <el-table-column label="Viajes" min-width="45px" prop="viajes"></el-table-column>
      <el-table-column label="Camiones" min-width="45px" prop="camiones"></el-table-column>
      <el-table-column label="Peso Neto Salida Puerto" min-width="110px" prop="pesoNetoSalida">
        <template  #default="props">
          {{ props.row.pesoNetoSalida }} TM <br>
          ({{ props.row.pesoPorHora }} <span style="color:rgb(23, 162, 184);">TM</span> por Hora)
        </template>
      </el-table-column>
      <el-table-column label="Peso Neto Ingreso Almacén" min-width="110px" prop="pesoNetoIngreso">
        <template  #default="props">
          {{ props.row.pesoNetoIngreso }} TM
        </template>
      </el-table-column>
      <el-table-column label="Diferencia de Pesos" min-width="90px">
        <template #default="props">
          <div :style="{ color: props.row.diferenciaPeso < 0 ? '#F59221' : '#529E02' }">
        <b>{{ props.row.diferenciaPeso }} TM</b>    
          </div>
        </template>
      </el-table-column>


    </el-table>


  </b-card>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import moment from 'moment'

export default {
  name: 'social-traffic-table',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    listaJornada: {
      type: Array,
      default: () => [],
    },
    listaDatosData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mostrarTabla: true, // Controla la visibilidad de la tabla
      coloresJornada: [
      "rgba(0, 77, 107, 1)", // #004D6B
      "rgba(0, 139, 139, 1)", // #008B8B
      // "rgba(255, 175, 29, 1)", // #FFAF1D
      // "rgba(255, 104, 0, 1)", // #FF6800
    ],
    };
  },
  methods:{

    obtenerColorJornada(idJornada) {
    // Convertir idJornada a un valor numérico simple para usar como índice
    let hash = 0;
    for (let i = 0; i < idJornada.length; i++) {
      hash = idJornada.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colorIndex = Math.abs(hash) % this.coloresJornada.length; // Usa el valor absoluto para evitar índices negativos
    return this.coloresJornada[colorIndex];
  },

    

      convertir(item){
      if(typeof(item)==="string")
      return parseFloat(item.replace(",", "."))
      if (typeof(item)==="number")
      return parseFloat(item.toString())
      
      },
   
    Jornada(idproductophite) {
         let pnetoTotal = ''
        let res =  this.listaJornada.filter(val => {
            return val.ID == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.JORNADA
        });

      return pnetoTotal;

      },

      
     
      ViajesBalanza(idproductophite) {
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite != 0;
        }).filter(function( element ) {
        return element.PESO_NETO_PUERTO !== 0;
        })
         return res.length;
      },

      Camiones(idproductophite) {
      let placasContadas = {};
    let contador = 0;

    this.DataCompleta.forEach(element => {
        // Verificamos las condiciones para cada elemento
        if (element.JORNADA == idproductophite && element.PESO_NETO_PUERTO !== 0) {
            // Si no hemos contado esta PLACA antes, la contamos y marcamos como contada
            if (!placasContadas.hasOwnProperty(element.PLACA)) {
                placasContadas[element.PLACA] = true; // Marcamos la PLACA como contada
                contador++; // Incrementamos el contador de PLACA únicas
            }
        }
    });

    // Devolvemos el contador de PLACA únicas encontradas que cumplen las condiciones
    return contador;
      },

      PnetoBalanza(idproductophite) {
         let pnetoTotal = 0
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_PUERTO
        });

      return pnetoTotal.toFixed(3);

      },

      DiferenciaJornadaPhite(idproductophite) {
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })
        

        res.forEach(element => {
         element.FECHA_FIN_CARGIO
        });

        let beta =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })
        

        beta.forEach(element => {
         element.FECHA_INICIO_CARGUIO
        });

        var date2 = moment(beta[beta.length -1].FECHA_FIN_CARGIO, 'DD-MM-YYYY HH:mm').format('MM-DD-YYYY HH:mm');
        var date1 = moment(res[0].FECHA_INICIO_CARGUIO, 'DD-MM-YYYY HH:mm').format('MM-DD-YYYY HH:mm');
        // var diff = date2.diff(date1, 'minutes');        

        var now = moment(date1),
        end = moment(date2),
        minutes = end.diff(now, 'Minutes');

        return minutes/60

      },

      PnetoAlmacenEnAlmacen(idproductophite) {
         let pnetoTotal = 0
        let res =  this.DataCompletaAlmacen.filter(val => {
            return val.JORNADA == idproductophite;
        })

        res.forEach(element => {
          pnetoTotal += element.PESO_NETO_ALMCEN
        });

      return pnetoTotal.toFixed(3);

      },


  },
  computed: {
    datosConsolidados() {
    const agrupadosPorJornada = {};

    // Procesamiento inicial basado en DataCompleta
    this.listaDatosData.forEach(item => {
      const jornadaId = item.JORNADA;

      if (!agrupadosPorJornada[jornadaId]) {
        agrupadosPorJornada[jornadaId] = {
          jornadaId: jornadaId,
          viajes: 0,
          transportes: {}, // Objeto para acumular los viajes por tipo de transporte
          camionesDetalle: {}, // Objeto para detallar los camiones
          pesoNetoSalida: 0,
          pesoNetoIngreso: 0, // Se ajustará con datos de listaDatosData
          inicioCarguio: moment('9999-12-31', 'YYYY-MM-DD'),
          finCarguio: moment('0000-01-01', 'YYYY-MM-DD'),
        };
      }

      const grupo = agrupadosPorJornada[jornadaId];
      grupo.viajes += 1;

      // Acumular los viajes y los camiones por TRANSPORTE
      const transporte = item.TRANSPORTE;
      if (!grupo.transportes[transporte]) {
        grupo.transportes[transporte] = {
          viajes: 1,
          camiones: new Set([item.PLACA]), // Inicializar con la placa del camión actual
          pesoNetoSalida: parseFloat(item.PESO_NETO_PUERTO || 0),
          pesoNetoIngreso: parseFloat(item.PESO_NETO_ALMCEN || 0), // Este valor se actualizará más adelante si es necesario
        };
      } else {
        grupo.transportes[transporte].viajes += 1;
        grupo.transportes[transporte].camiones.add(item.PLACA);
        grupo.transportes[transporte].pesoNetoSalida += parseFloat(item.PESO_NETO_PUERTO || 0);
        grupo.transportes[transporte].pesoNetoIngreso += parseFloat(item.PESO_NETO_ALMCEN || 0);
      }

      grupo.pesoNetoSalida += parseFloat(item.PESO_NETO_PUERTO || 0);
      grupo.pesoNetoIngreso += parseFloat(item.PESO_NETO_ALMCEN || 0);

      const fechaInicio = moment(item.FECHA_INICIO_CARGUIO, 'DD-MM-YYYY HH:mm');
      const fechaFin = moment(item.FECHA_FIN_CARGIO, 'DD-MM-YYYY HH:mm');
      if (fechaInicio.isValid() && fechaInicio.isBefore(grupo.inicioCarguio)) {
        grupo.inicioCarguio = fechaInicio;
      }
      if (fechaFin.isValid() && fechaFin.isAfter(grupo.finCarguio)) {
        grupo.finCarguio = fechaFin;
      }
    });

    // Asignación de nombres de jornada desde listaJornada y cálculo de diferencias
    Object.values(agrupadosPorJornada).forEach(grupo => {
      const jornadaInfo = this.listaJornada.find(j => j.ID === grupo.jornadaId);
      grupo.jornada = jornadaInfo ? jornadaInfo.JORNADA : 'Desconocido';

      // Calcular la diferencia de peso a nivel de transporte
      Object.values(grupo.transportes).forEach(transporte => {
        transporte.diferenciaPeso = transporte.pesoNetoIngreso - transporte.pesoNetoSalida;
      });
    });

    // Preparación de los datos finales para la tabla, incluyendo ordenamiento y filtrado
    return Object.values(agrupadosPorJornada).map(grupo => {
      const duracionHoras = grupo.finCarguio.diff(grupo.inicioCarguio, 'hours', true);

      // Convertir el objeto transportes en un array de objetos para cada transporte
      const transportesArray = Object.entries(grupo.transportes).map(([nombreTransporte, data]) => ({
        transporte: nombreTransporte,
        viajes: data.viajes,
        cantidadCamiones: data.camiones.size,
        pesoNetoSalida: data.pesoNetoSalida.toFixed(3),
        pesoNetoIngreso: data.pesoNetoIngreso.toFixed(3),
        diferenciaPeso: data.diferenciaPeso.toFixed(3),
      }));

      return {
        jornada: grupo.jornada,
        viajes: grupo.viajes,
        transportes: transportesArray,
        camiones: Array.from(new Set([...Object.values(grupo.transportes).flatMap(t => Array.from(t.camiones))])).length,
        pesoNetoSalida: grupo.pesoNetoSalida.toFixed(3),
        pesoNetoIngreso: grupo.pesoNetoIngreso.toFixed(3),
        diferenciaPeso: (grupo.pesoNetoIngreso - grupo.pesoNetoSalida).toFixed(3),
        pesoPorHora: duracionHoras > 0 ? (grupo.pesoNetoSalida / duracionHoras).toFixed(3) : '0.000',
      };
    })
    .sort((a, b) => {
      const numA = a.jornada.replace(/[^\d]/g, '');
      const numB = b.jornada.replace(/[^\d]/g, '');
      return numA - numB;
    })
    .filter(grupo => grupo.viajes > 0);
  },

  

  TransporteUnico() {
      let unique = [
        ...new Set(this.listaDatosData.map((productlist) => productlist.TRANSPORTE)),
      ];
      return unique.map((name) => ({ name }));
    },

    JornadaFiltrada() {
      return this.JornadaUnica.filter(row => this.ViajesBalanza(row) > 0);
    },

    JornadaUnica() {
      let jornada = [
        ...new Set(this.listaJornada.map((productlist) => productlist.ID)),
      ];
      return jornada;
    },

    DataCompleta() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_ALMCEN: this.convertir(item.PESO_NETO_ALMCEN),
          PESO_NETO_PUERTO: this.convertir(item.PESO_NETO_PUERTO),
          ID_PRODUCTO: item.ID_PRODUCTO,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          FECHA_INICIO_CARGUIO: item.FECHA_INICIO_CARGUIO,
          FECHA_FIN_CARGIO: item.FECHA_FIN_CARGIO,
          JORNADA: item.JORNADA,
          TRANSPORTE:item.TRANSPORTE,
          PLACA: item.PLACA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
        };
            }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        })
              },

              DataCompletaAlmacen() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_ALMCEN: this.convertir(item.PESO_NETO_ALMCEN),
          FECHA_INGRESO_ALMACEN: item.FECHA_INGRESO_ALMACEN,
          PLACA: item.PLACA,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          JORNADA: item.JORNADA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
                };
            }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== undefined;
        }).filter(function( element ) {
          return element.FECHA_INGRESO_ALMACEN !== 0;
        })
      },
         

  },
};
</script>

<style>
.el-table__expanded-cell[class*=cell] {
    padding: 20px 50px !important;
}
</style>
